var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4750_32501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37789 13.9018C3.53789 13.9018 3.56989 13.8858 3.71389 13.8538L6.59389 13.2778C6.89789 13.1978 7.20189 13.0538 7.44189 12.8138L14.4179 5.83778C15.4899 4.76578 15.4899 2.92578 14.4179 1.85378L13.8259 1.22978C12.7539 0.157781 10.8979 0.157781 9.82589 1.22978L2.84989 8.22178C2.62589 8.44578 2.46589 8.76578 2.38589 9.06978L1.77789 11.9818C1.69789 12.5258 1.85789 13.0538 2.24189 13.4378C2.54589 13.7418 2.99389 13.9018 3.37789 13.9018ZM3.92189 9.37378L10.8979 2.38178C11.3619 1.91778 12.2099 1.91778 12.6579 2.38178L13.2659 2.98978C13.8099 3.53378 13.8099 4.30178 13.2659 4.82978L6.30589 11.8218L3.34589 12.3178L3.92189 9.37378Z",
    fill: "#3CEAC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3572 14.8936H2.54925C2.08525 14.8936 1.78125 15.1976 1.78125 15.6616C1.78125 16.1256 2.16525 16.4296 2.54925 16.4296H14.2932C14.7572 16.4296 15.1412 16.1256 15.1412 15.6616C15.1252 15.1976 14.7412 14.8936 14.3572 14.8936Z",
    fill: "#3CEAC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4750_32501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.429688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.ea5a322d98918248b6f045c5655ee432.svg";
export { ForwardRef as ReactComponent };